/* Santa Steals promo (Kinetik). Loaded only by templates/collection.santa-steals.json, templates/product.santa-steals.json
   and the home page "Santa Steals Carousel" section. Card mode also prices the Quick view / Quick add drawers opened from those cards.
   Reads the LIVE automatic discount % via a Storefront API cart, so nothing needs editing if the discount changes or ends. */
(function () {
  var me = document.currentScript;
  var MODE = me.getAttribute('data-mode');            // 'card' or 'pdp'
  var VID = me.getAttribute('data-vid');              // available variant in the collection, used to probe the discount
  var KEY = 'ssSantaAutoPct', TTL = 10 * 60 * 1000, pct = null;
  var RED = '#991D1B';

  var css = '' +
    '.ss-cp{width:100%;margin-top:6px;font-size:13px;line-height:1.35;font-weight:400;color:' + RED + '}' +
    '.ss-cp b{font-weight:700}' +
    '.ss-callout{display:flex;align-items:center;gap:10px;margin:4px 0 8px;padding:10px 14px;border:1px solid #e6c3c2;border-left:4px solid ' + RED + ';border-radius:8px;background:#f9eeee;color:' + RED + ';font-size:15px;line-height:1.35;font-weight:600}' +
    '.ss-callout b{font-weight:800}' +
    '.ss-badge{background:' + RED + ' !important;color:#fff !important}' +
    '.product-card__media .ss-badge{font-size:10px !important;padding:5px 9px !important;letter-spacing:.04em;font-weight:600 !important}' +
    '.ss-badge--inline{display:inline-flex;align-items:center;align-self:center;padding:5px 10px;font-size:12px;letter-spacing:.02em}' +
    '.ss-pill{display:inline-flex;align-items:center;align-self:center;background:' + RED + ';color:#fff;font-size:10px;font-weight:700;letter-spacing:.04em;line-height:1;padding:4px 7px;border-radius:999px;white-space:nowrap}' +
    '@media (max-width:767px){' +
      '.ss-cp{font-size:12px;margin-top:4px}.ss-cp .ss-sep{display:none}.ss-cp .ss-l1,.ss-cp .ss-l2{display:block}' +
      '.product-card__media .ss-badge{font-size:9px !important;padding:4px 7px !important}' +
      '.ss-pill{font-size:9px;padding:3px 6px}' +
      '.ss-callout{font-size:14px;padding:9px 12px}' +
    '}';
  if (MODE === 'pdp') css +=
    '@media (max-width:767px){' +
      '[id$="__17721186778d0947b7"] > div{padding-top:4px !important;padding-bottom:0 !important}' +
      '[id$="__17721186778d0947b7"] a{padding-top:6px !important;padding-bottom:6px !important}' +
      '[id$="__main-product"] .featured-product{gap:14px !important}' +
      '[id$="__main-product"] .product__info > *{margin-top:14px !important}' +
      '[id$="__main-product"] .product__info > :first-child{margin-top:0 !important}' +
      '[id$="__main-product"] .product__info > .product-form-wrapper{margin-top:18px !important}' +
      '[id$="__main-product"] .product__title{gap:6px !important}' +
      '[id$="__main-product"] .countdown_timer.ss-cd-top{margin:0 !important;width:100%;padding:8px 10px !important}' +
      '.ss-cd-top .countdown_timer_wrapper{flex-direction:row !important;align-items:center;justify-content:space-between;gap:8px !important;width:100%}' +
      '.ss-cd-top .countdown_timer__svg{display:none !important}' +
      '.ss-cd-top .text_desktop{font-size:14px !important;line-height:1.2 !important}' +
      '.ss-cd-top .countdown_timer__subtitle{font-size:11px !important}' +
      '.ss-cd-top .countdown_timer__wrapper{gap:3px !important}' +
      '.ss-cd-top .countdown_timer__box{padding:5px 4px !important}' +
      '.ss-cd-top .countdown_timer__time{font-size:15px !important;line-height:1.1 !important}' +
      '.ss-cd-top .countdown_timer__label{font-size:9px !important}' +
      '.ss-cd-top .countdown_timer__dot{font-size:16px !important;line-height:1 !important}' +
    '}';
  if (MODE === 'card') css +=
    '[id$="__main-collection-banner"] .banner{margin-bottom:188px !important}' +
    '[id$="__main-collection-banner"] .breadcrumb ul,[id$="__main-collection-banner"] .breadcrumb li{gap:10px !important}' +
    '[id$="__main-collection-banner"] .breadcrumb li + li::before{content:"/" !important;width:auto !important;height:auto !important;border:0 !important;background:none !important;transform:none !important;opacity:.45;position:static !important}' +
    '[id$="__main-collection"] .product-card__details > div,[id$="__santa_steals_carousel"] .product-card__details > div{width:100%}' +
    '.ss-cp{margin-top:-2px}' +
    '[id$="__santa_steals_carousel"] .title-wrapper > .grid{gap:8px !important}' +
    '[id$="__santa_steals_carousel"] .title-wrapper p.subtext-lg{font-size:13px !important;font-weight:700 !important;letter-spacing:.12em !important;text-transform:uppercase !important;color:' + RED + ' !important}' +
    '@media (max-width:767px){[id$="__santa_steals_carousel"] .title-wrapper p.subtext-lg{font-size:12px !important}[id$="__santa_steals_carousel"] .title-wrapper .description{font-size:14px !important}}' +
    '@media (max-width:767px){[id$="__main-collection-banner"] .banner{margin-bottom:148px !important}}';
  css +=   // product price box: used on the product page and inside Quick view
    '[id$="__main-product"] .countdown_timer_wrapper{flex-wrap:wrap;row-gap:12px}' +
    '[id$="__main-product"] .countdown_timer__text p{white-space:nowrap}' +
    '.ss-on .product__title .product__price{display:none !important}' +
    '.ss-on .product__title.with-price{display:block !important}' +
    '.ss-pricebox{margin-top:10px !important}' +
    '.ss-pricerow{display:flex;flex-wrap:wrap;align-items:center;column-gap:14px;row-gap:6px}' +
    '.ss-from{font-size:15px;color:#586872}' +
    '.ss-was{font-size:22px;color:#9aa3a9;text-decoration-thickness:2px}' +
    '.ss-now{font-size:30px;font-weight:700;color:#1f2a33;line-height:1}' +
    '.ss-tag{background:' + RED + ';color:#fff;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:5px 8px;border-radius:4px;line-height:1}' +
    '.ss-note{margin:8px 0 0 !important;font-size:15px;font-weight:400;color:' + RED + ';letter-spacing:.01em}' +
    '.ss-note b{font-weight:700}.ss-dot{opacity:.6;margin:0 2px}' +
    '.ss-save{margin:8px 0 0 !important;font-size:13px;font-weight:500;color:#9aa3a9}' +
    '.ss-final{margin:6px 0 0 !important;font-size:13px;font-weight:600;color:#586872}' +
    '.ss-sticky{display:flex;flex-wrap:wrap;align-items:baseline;column-gap:6px;font-size:14px;line-height:1.3;color:#586872}' +
    '.ss-sticky s{color:#9aa3a9}.ss-sticky b{color:#1f2a33;font-size:16px;font-weight:700}.ss-sticky span{color:' + RED + ';font-size:12px;font-weight:600}' +
    '.ss-short{display:none}@media (max-width:767px){.ss-save{font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ss-long{display:none}.ss-short{display:inline}}' +
    '.ss-break{margin:0;max-width:380px;display:grid;row-gap:6px}' +
    '.ss-br{display:flex;justify-content:space-between;align-items:baseline;gap:16px;font-size:15px;color:#586872}' +
    '.ss-br dt,.ss-br dd{margin:0}' +
    '.ss-br s{color:#9aa3a9;text-decoration-thickness:2px}' +
    '.ss-br--disc{color:' + RED + ';font-weight:600}' +
    '.ss-br--final{margin-top:4px;padding-top:10px;border-top:1px solid #e3e6e8;color:#1f2a33;font-weight:700;font-size:17px}' +
    '.ss-br--final dd{font-size:28px;line-height:1}' +
    '@media (max-width:767px){.ss-break{max-width:none}.ss-br{font-size:14px}.ss-br--final{font-size:16px}.ss-br--final dd{font-size:24px}}' +
    'product-buy-price.ss-hide{display:none !important}' +
    '.ss-btnprice{white-space:nowrap}.ss-btnprice s{opacity:.65;margin-right:4px;font-weight:400}' +
    '@media (max-width:767px){.ss-was{font-size:18px}.ss-now{font-size:26px}.ss-note{font-size:13px}}' +
    '.ss-crumb-row{display:flex !important;align-items:center;flex-wrap:nowrap !important;column-gap:6px;width:auto !important;max-width:100%}' +
    '.ss-crumb{display:flex !important;align-items:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.ss-crumb > *{margin:0 !important}' +
    '.ss-crumb{margin:0 !important;font-size:14px;line-height:1.3;color:#586872}' +
    '.ss-crumb::before{content:"|";opacity:.35;margin-right:10px}' +
    '.ss-crumb a{text-decoration:none !important;background-image:none !important;border-bottom:0 !important}.ss-crumb a:hover{text-decoration:underline !important}' +
    '.ss-crumb strong{font-weight:600}' +
    '@media (max-width:767px){.ss-crumb{font-size:13px}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function fmt(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function finalFrom(regEl) {
    if (!regEl) return null;
    var raw = regEl.textContent; var n = parseFloat(raw.replace(/[^0-9.]/g, ''));
    if (!(n > 0)) return null;
    var c = Math.round(n * 100);
    return { from: raw.toLowerCase().indexOf('from') > -1, cents: c - Math.round(c * pct / 100) };
  }
  function html(f, onSale) {
    return '<span class="ss-l1">' + (onSale ? 'Additional ' : '') + pct + '% Off:</span><span class="ss-sep"> </span>' +
           '<span class="ss-l2"><b>' + (f.from ? 'From ' : '') + fmt(f.cents) + ' at Checkout</b></span>';
  }
  function setBadge(container, holder) {
    if (!container && holder) { container = document.createElement('div'); container.className = 'badges pointer-events-none'; holder.appendChild(container); }
    if (!container) return;
    var b = container.querySelector('.ss-badge');
    if (!(pct > 0)) { if (b) b.remove(); return; }
    var txt = '+' + pct + '% OFF';
    if (!b) { b = document.createElement('span'); b.className = 'badge badge--onsale ss-badge flex items-center gap-1d5 font-medium leading-none rounded-full'; }
    if (container.lastElementChild !== b) container.appendChild(b);   // sits below any Sale / Final Sale tags
    if (b.textContent !== txt) b.textContent = txt;
  }

  function runCards() {
    document.querySelectorAll('[id$="__main-collection"] .product-card, [id$="__santa_steals_carousel"] .product-card').forEach(function (card) {
      var price = card.querySelector('.price'); if (!price) return;
      var line = card.querySelector('.ss-cp');
      // "+X% OFF" pill sits in the price row (off the product image, aligned with the price)
      var oldB = card.querySelector('.product-card__media .ss-badge'); if (oldB) oldB.remove();
      var pill = price.querySelector('.ss-pill');
      if (!(pct > 0)) { if (line) line.remove(); if (pill) pill.remove(); return; }
      var onSale = !!price.querySelector('.price__sale');
      var ptxt = (onSale ? '+' : '') + pct + '% OFF';
      if (!pill) { pill = document.createElement('span'); pill.className = 'ss-pill'; price.appendChild(pill); }
      if (pill.textContent !== ptxt) pill.textContent = ptxt;
      var f = finalFrom(price.querySelector('.price__regular')); if (!f) return;
      var h = html(f, onSale);
      if (!line) { line = document.createElement('div'); line.className = 'ss-cp'; price.insertAdjacentElement('afterend', line); }
      if (line.innerHTML !== h) line.innerHTML = h;
    });
  }

  // Final Sale status comes from the product's "Final Sale" tag (same tag Loop uses to block returns/exchanges)
  var FS = {};
  function handleOf(u) { u = u || ''; var i = u.indexOf('/products/'); if (i < 0) return null; return u.slice(i + 10).split('?')[0].split('#')[0].split('/')[0] || null; }
  function isFinal(h) {
    if (!h) return false;
    if (FS[h] === undefined) {
      FS[h] = false;
      fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (d) {
        FS[h] = (d.tags || []).some(function (t) { return String(t).toLowerCase() === 'final sale'; }); if (FS[h]) run();
      }).catch(function () {});
    }
    return FS[h];
  }

  function runPdp(main, handle) {
    if (!main) return;
    var fin = isFinal(handle) ? '<p class="ss-final">Final Sale &middot; no returns or exchanges</p>' : '';
    var banner = main.querySelector('.discount');                 // old "Save an Extra 50% Off" text block (replaced)
    var title = main.querySelector('.product__title');
    var oldBox = main.querySelector('.ss-callout'); if (oldBox) oldBox.remove();
    var oldB = main.querySelector('.product__price .ss-badge'); if (oldB) oldB.remove();
    var row = main.querySelector('.ss-pricebox');
    if (banner) banner.style.display = 'none';
    if (!(pct > 0)) { if (row) row.remove(); main.classList.remove('ss-on');
      main.querySelectorAll('.ss-btnprice').forEach(function (e) { e.remove(); });
      main.querySelectorAll('product-buy-price.ss-hide').forEach(function (e) { e.classList.remove('ss-hide'); }); return; }
    var reg = main.querySelector('.product__price .price .price__regular');
    var cmpEl = main.querySelector('.product__price .price .price__sale');   // compare-at ("was") price, if any
    var f = finalFrom(reg); if (!f || !title) return;
    var cur = reg.textContent.replace(/from/i, '').trim();
    var cmp = cmpEl ? cmpEl.textContent.trim() : '';
    var was = cmp || cur;
    var cmpC = cmp ? Math.round(parseFloat(cmp.replace(/[^0-9.]/g, '')) * 100) : 0;
    var note = cmp
      ? 'Sale price ' + cur + ' <span class="ss-dot">&middot;</span> <b>Additional ' + pct + '% Off at Checkout</b>'
      : '<b>Additional ' + pct + '% Off</b> applied at Checkout';
    var h = (cmp && cmpC > f.cents) ?
      // Compare-at products: step-by-step breakdown
      '<dl class="ss-break">' +
        '<div class="ss-br"><dt>Original price</dt><dd><s>' + cmp + '</s></dd></div>' +
        '<div class="ss-br"><dt>Sale price</dt><dd>' + cur + '</dd></div>' +
        '<div class="ss-br ss-br--disc"><dt>Additional ' + pct + '% off</dt><dd>&minus;' + fmt(Math.round(f.cents / (1 - pct / 100)) - f.cents) + '</dd></div>' +
        '<div class="ss-br ss-br--final"><dt>Final price at checkout</dt><dd>' + (f.from ? 'From ' : '') + fmt(f.cents) + '</dd></div>' +
      '</dl>' +
      '<p class="ss-save">You save ' + fmt(cmpC - f.cents) + ' (' + Math.round((cmpC - f.cents) * 100 / cmpC) + '%) &middot; <span class="ss-long">applied automatically, no code needed</span><span class="ss-short">auto-applied, no code needed</span></p>' + fin
      :
      // Regular-price products: same breakdown, worded as one discount (not "additional")
      '<dl class="ss-break">' +
        '<div class="ss-br"><dt>Original price</dt><dd><s>' + cur + '</s></dd></div>' +
        '<div class="ss-br ss-br--disc"><dt>Santa Steals ' + pct + '% off</dt><dd>&minus;' + fmt(Math.round(f.cents / (1 - pct / 100)) - f.cents) + '</dd></div>' +
        '<div class="ss-br ss-br--final"><dt>Final price at checkout</dt><dd>' + (f.from ? 'From ' : '') + fmt(f.cents) + '</dd></div>' +
      '</dl>' +
      '<p class="ss-save">You save ' + fmt(Math.round(f.cents / (1 - pct / 100)) - f.cents) + ' (' + pct + '%) &middot; <span class="ss-long">applied automatically, no code needed</span><span class="ss-short">auto-applied, no code needed</span></p>' + fin;
    // Add to cart button: show the price the customer will actually pay (follows quantity/variant changes)
    main.querySelectorAll('product-buy-price').forEach(function (bp) {
      var bc = Math.round(parseFloat(bp.textContent.replace(/[^0-9.]/g, '')) * 100); if (!(bc > 0)) return;
      var bf = bc - Math.round(bc * pct / 100);
      var tag = bp.nextElementSibling && bp.nextElementSibling.classList.contains('ss-btnprice') ? bp.nextElementSibling : null;
      var bh = fmt(bf);   // the price the customer actually pays
      if (!tag) { tag = document.createElement('span'); tag.className = 'ss-btnprice'; bp.insertAdjacentElement('afterend', tag); }
      if (tag.innerHTML !== bh) tag.innerHTML = bh;
      bp.classList.add('ss-hide');
    });
    if (!row) { row = document.createElement('div'); row.className = 'ss-pricebox'; title.insertAdjacentElement('afterend', row); }
    if (row.innerHTML !== h) row.innerHTML = h;
    main.classList.add('ss-on');
  }

  // Sticky add-to-cart bar (product page): show the checkout price instead of the pre-discount price
  function runSticky() {
    document.querySelectorAll('[id^="StickyPrice-"][id*="__main-product"]').forEach(function (sp) {
      var pr = sp.querySelector('.price'); var reg = pr && pr.querySelector('.price__regular');
      var f = (pct > 0) ? finalFrom(reg) : null; var tag = sp.querySelector('.ss-sticky');
      if (!f) { if (tag) tag.remove(); if (pr) pr.style.display = ''; return; }
      var cmpEl = pr.querySelector('.price__sale');
      var was = cmpEl ? cmpEl.textContent.trim() : reg.textContent.replace(/from/i, '').trim();
      var h = '<s>' + was + '</s> <b>' + (f.from ? 'From ' : '') + fmt(f.cents) + '</b> <span>at checkout</span>';
      if (!tag) { tag = document.createElement('div'); tag.className = 'ss-sticky'; sp.appendChild(tag); }
      if (tag.innerHTML !== h) tag.innerHTML = h;
      if (pr.style.display !== 'none') pr.style.display = 'none';
    });
  }

  // Breadcrumb: move it into the "Go back" row so it isn't a stray line above the title.
  function placeCrumb() {
    if (MODE !== 'pdp') return;
    var crumb = document.querySelector('[id$="__main-product"] .santacrumb, .ss-crumb');
    var row = document.querySelector('[id$="__17721186778d0947b7"] [class^="ai-back-link"]');
    if (!crumb || !row || crumb.parentNode === row) return;
    crumb.classList.add('ss-crumb'); row.classList.add('ss-crumb-row'); row.appendChild(crumb);
  }

  // Mobile: move the sale countdown above the photo gallery; desktop: put it back in the info column.
  var mq = window.matchMedia('(max-width: 767px)'), cdHome = null;
  function placeCountdown() {
    if (MODE !== 'pdp') return;
    var main = document.querySelector('[id$="__main-product"]'); if (!main) return;
    var cd = main.querySelector('.countdown_timer'); var gal = main.querySelector('.product__gallery-container');
    if (!cd || !gal) return;
    if (!cdHome) { cdHome = document.createComment('ss-countdown-home'); cd.parentNode.insertBefore(cdHome, cd); }
    if (mq.matches) { if (cd.nextElementSibling !== gal) { gal.parentNode.insertBefore(cd, gal); cd.classList.add('ss-cd-top'); } }
    else if (cdHome.nextSibling !== cd) { cdHome.parentNode.insertBefore(cd, cdHome.nextSibling); cd.classList.remove('ss-cd-top'); }
  }
  if (mq.addEventListener) mq.addEventListener('change', placeCountdown);

  function run() { placeCrumb(); placeCountdown(); if (pct === null) return; if (MODE === 'pdp') { runPdp(document.querySelector('[id$="__main-product"]'), handleOf(location.pathname)); runSticky(); return; }
    runCards();
    // Quick view / Quick add drawers opened from Santa Steals cards (loaded on demand)
    document.querySelectorAll('quick-view[id*="__main-collection-"] .quick-view__content, quick-view[id*="__santa_steals_carousel-"] .quick-view__content').forEach(function (c) {
      if (c.querySelector('.product__title .product__price')) runPdp(c, handleOf(c.closest('quick-view').getAttribute('data-product-url')));
    });
  }
  function done(p) { pct = p; try { sessionStorage.setItem(KEY, JSON.stringify({ p: p, t: Date.now() })); } catch (e) {} run(); }

  function load() {
    try { var s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (s && Date.now() - s.t < TTL) { pct = s.p; run(); return; } } catch (e) {}
    if (!VID) { pct = 0; run(); return; }
    var Q = 'mutation($l:[CartLineInput!]){cartCreate(input:{lines:$l}){cart{lines(first:1){nodes{discountAllocations{discountApplication{targetType value{__typename ... on PricingPercentageValue{percentage}}}}}}}}}';
    fetch('/api/2025-07/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ query: Q, variables: { l: [{ merchandiseId: 'gid://shopify/ProductVariant/' + VID, quantity: 1 }] } })
    }).then(function (r) { return r.json(); }).then(function (d) {
      var p = 0;
      try { d.data.cartCreate.cart.lines.nodes[0].discountAllocations.forEach(function (a) {
        var ap = a.discountApplication || {}, v = ap.value || {};
        if (ap.targetType === 'LINE_ITEM' && v.percentage > p) p = v.percentage;
      }); } catch (e) {}
      done(p);
    }).catch(function () { pct = 0; run(); });
  }

  var tm; function q() { clearTimeout(tm); tm = setTimeout(run, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(q).observe(document.documentElement, { childList: true, subtree: true });
  run();
  load();
})();
